(function($) {
    $(document).ready(function() {
        // Otwieranie modala
        $('.open-modal').on('click', function() {
            var modalId = $(this).data('modal-id');
            $('#' + modalId).fadeIn();
        });
    
        // Zamykanie modala po kliknięciu na "x" lub przycisk zamknij
        $(document).on('click', '.close, .close-modal-btn', function() {
            var modalId = $(this).data('modal-id');
            if (modalId) {
                $('#' + modalId).fadeOut();
            } else {
                // Zamknij wszystkie otwarte modale
                $('.modal').fadeOut();
            }
        });
    
        // Zamykanie modala po kliknięciu poza obrysem (na overlay)
        $(document).on('click', '.modal', function(e) {
            // jeśli klik nie był wewnątrz .modal-content, zamknij ten modal
            if ($(e.target).closest('.modal-content').length === 0) {
                $(this).fadeOut();
            }
        });
    });
})(jQuery);